import { createFileRoute, useParams } from '@tanstack/react-router';
import { AppBundle } from '@/utils/app-bundles';
import Journeys from '@/pages/journeys';
import { JourneysDataIndexItemHandoff } from '@/pages/workspaces/data-index/routing';
import { DataIndexItemResolver } from '@/pages/workspaces/data-index/data-index-item-resolver';
import { LastWorkspaceResolver } from './-route-layouts';

/** The `journeys` spelling of a person attribute's or event's own page. */
function JourneysDataIndexItemRoute() {
  const { type, itemId } = useParams({
    from: '/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/$itemId/',
  });

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <DataIndexItemResolver segment={type} itemId={itemId} fallback={<Journeys />}>
        {(address) => <JourneysDataIndexItemHandoff address={address} />}
      </DataIndexItemResolver>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/data-index/$type/$itemId/')({
  component: JourneysDataIndexItemRoute,
});
